
import { MarcaModel } from '@/store/catalogos/marcas';
import { properties } from '@/utils/properties';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class CatalogoMarcaService {
  private readonly baseUrl = properties.URL_CATALOGOS + 'marcas';

  constructor(private http: HttpClient) { }

  getAll(): Observable<MarcaModel[]> {
    return this.http.get<MarcaModel[]>(this.baseUrl, httpOptions);
  }

  create(marca: MarcaModel): Observable<MarcaModel> {
    return this.http.post<MarcaModel>(this.baseUrl, marca, httpOptions);
  }

  update(marca: MarcaModel): Observable<MarcaModel> {
    return this.http.put<MarcaModel>(`${this.baseUrl}/${marca.idMarca}`, marca, httpOptions);
  }


}
